function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.011 2.9l.906.054c2.465-1.178 4.625-1.315 5.744-.13.887.941.967 2.552.381 4.453A8.593 8.593 0 0120 11.24l-.049.927H8.531c.33 2.115 1.763 3.706 3.48 3.706 1.162 0 2.193-.728 2.841-1.853h4.693c-1.096 3.24-4.055 5.56-7.534 5.56a7.676 7.676 0 01-3.19-.692c-2.597 1.322-4.897 1.524-6.064.287-1.398-1.481-.793-4.628 1.266-7.941a23.61 23.61 0 013.164-4.022l.725-.716a18.268 18.268 0 00-3.724 3.047c.75-3.792 3.968-6.642 7.823-6.642zm0 3.707c-1.59 0-2.935 1.364-3.388 3.243H15.4c-.452-1.88-1.798-3.243-3.388-3.243zm6.268-2.723c-.584-.618-1.638-.662-2.945-.23a8.116 8.116 0 013.252 2.848c.288-1.146.209-2.07-.307-2.618zM3.922 18.644c.74.783 2.232.644 4.04-.214-1.64-1.008-2.904-2.61-3.522-4.524-1.064 2.106-1.324 3.882-.518 4.738z"
});

var SvgBrowserIe = function SvgBrowserIe(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/browser-ie.b958ad8d.svg";
export { SvgBrowserIe as ReactComponent };